<template>
  <div class="wrapper">
    <div class="container">
      <div class="basic">{{$t('T_BASIC_SETTINGS')}}</div>
      <hr/>
      <div class="select-container">
        <el-row class="esc-row row-item">
          <el-col :span="8">1. {{$t('T_REGION_SETTINGS')}}</el-col>
          <el-col :span="16" class="select">
            <span>{{$t('T_ESCS_NAME')}}</span>
            <el-select v-model="escValue" popper-class="esc-select" class="esc-select-item select-item" :placeholder="$t('T_SEARCH_CONDITION_PLEASE_SELECT')">
              <el-option
                v-for="item in escOptions"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              ></el-option>
            </el-select>
          </el-col>
        </el-row>
        <el-row class="function-row row-item">
          <el-col :span="10">2. {{$t('T_FUNCTION_CHECK')}}</el-col>
          <el-col :span="14">
            <el-checkbox-group v-model="checkedFunctions" :min="1">
              <el-checkbox v-for="searchFunction in functionOptions" :label="searchFunction" :key="searchFunction.value">{{$t(searchFunction.title)}}</el-checkbox>
            </el-checkbox-group>
            <span v-if="isBasic || isPortal">
              <el-checkbox v-model="edgeBlendingChecked" class="advanced-function-checkbox">{{$t('T_EDGE_BLENDING')}}</el-checkbox>
              <el-checkbox v-model="curvedSurfaceChecked" class="advanced-function-checkbox">{{$t('T_CURVE_SURFACE')}}</el-checkbox>
            </span>
            <el-checkbox v-model="cameraAssistChecked" class="advanced-function-checkbox">{{$t('T_CAMERA_BLENDING')}}</el-checkbox>
          </el-col>
        </el-row>
        <el-row class="default-item row-item">
          <el-col :span="7">3. {{$t('T_SELECT_DEFAULT_SETTING')}}</el-col>
          <el-col :span="8" class="select">
            <div class="default-lang">
              <span>{{$t('T_DEFAULT_LANGUAGE')}}</span>
              <el-select v-model="languageValue" popper-class="language-select" class="select-item" :placeholder="$t('T_SEARCH_CONDITION_PLEASE_SELECT')">
                <el-option
                  v-for="item in options"
                  :key="item.value"
                  :label="$t(item.label)"
                  :value="item.value"
                ></el-option>
              </el-select>
            </div>
            <div>
              <span>{{$t('T_DEFAULT_UNIT')}}</span>
              <el-select v-model="unitValue" :placeholder="$t('T_SEARCH_CONDITION_PLEASE_SELECT')">
                <el-option
                  v-for="item in unitDataOptions"
                  :key="item.value"
                  :label="$t(item.value)"
                  :value="item.value"
                ></el-option>
              </el-select>
            </div>
          </el-col>
          <el-col :span="9" class="select">
            <div class="default-simulator">
              <span>{{$t('T_DEFAULT_SIMULATOR')}}</span>
              <el-select v-model="simulatorValue" class="select-item" :placeholder="$t('T_SEARCH_CONDITION_PLEASE_SELECT')">
                <el-option
                    v-for="item in simulatorOptions"
                    :key="item.value"
                    :label="$t(item.label)"
                    :value="item.value"
                    :disabled="item.disabled"
                  ></el-option>
              </el-select>
            </div>
            <div>
              <span>{{$t('T_DEFAULT_SEARCH_TAB')}}</span>
              <el-select v-model="searchTabValue" :placeholder="$t('T_SEARCH_CONDITION_PLEASE_SELECT')" :disabled="searchTabDisabled">
                <el-option
                  v-for="item in searchTabOptions"
                  :key="item.value"
                  :label="$t(item.title)"
                  :value="item.value"
                  :disabled="item.disabled"
                ></el-option>
              </el-select>
            </div>
          </el-col>
        </el-row>
      </div>
      <div class="butbg">
        <div class="savefile">
          <el-button type="button" @click="saveFile()">{{$t('T_BUTTON_SAVE')}}</el-button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import { saveAs } from 'file-saver'
const basicFunctionOptions = [
  {title: 'T_SEARCH_MODEL', value: 'Search'},
  {title: 'T_SEARCH_CATEGORY', value: 'Categolies'},
  {title: 'T_SEARCH_SPEC', value: 'Specification'},
  {title: 'T_SEARCH_CONDITION', value: 'InstallCondition'}
]
const advancedFunctionOptions = [
  {title: 'T_EDGE_BLENDING', value: 'Blending'},
  {title: 'T_CURVE_SURFACE', value: 'CurvedSurface'}
]
const cameraFunctionOptions = [
  {title: 'T_CAMERA_BLENDING', value: 'CameraAssist'}
]
export default {
  name: 'simulatorMainTab',
  data () {
    return {
      checkedFunctions: [],
      languageValue: this.InitConfig.initLanguage,
      unitValue: this.InitConfig.initUnit,
      searchTabValue: this.InitConfig.initSearchTab,
      searchTabOptions: [],
      escValue: this.InitConfig.initEsc,
      simulatorValue: this.InitConfig.initSimulator,
      simulatorOptions: [
        {
          value: 'Basic',
          label: 'T_SIMPLE_MODE',
          disabled: false
        },
        {
          value: 'Advanced',
          label: 'T_ADVANCED_MODE'
        },
        {
          value: 'Top',
          label: 'T_PORTAL_SITE_MODE'
        }
      ],
      escOptions: [{
        value: 'ehc',
        label: 'EHC'
      }, {
        value: 'eai',
        label: 'EAI'
      }, {
        value: 'eaiLatin',
        label: 'EAI Latin'
      }, {
        value: 'eaiBrazil',
        label: 'EAI Brazil'
      }, {
        value: 'eaiBrazil2',
        label: 'EAI Brazil2'
      }, {
        value: 'eeb',
        label: 'EEB'
      }, {
        value: 'eul',
        label: 'EUL'
      }, {
        value: 'ekl',
        label: 'EKL'
      }, {
        value: 'esp',
        label: 'ESP'
      }, {
        value: 'eal',
        label: 'EAL'
      }, {
        value: 'ett',
        label: 'ETT'
      }, {
        value: 'ein',
        label: 'EIN'
      }, {
        value: 'epil',
        label: 'EPIL'
      }, {
        value: 'ehk',
        label: 'EHK'
      }, {
        value: 'ecc',
        label: 'ECC'
      }, {
        value: 'emo',
        label: 'EMO'
      }],
      edgeBlendingChecked: this.InitConfig.initFunction.indexOf('Blending') !== -1,
      curvedSurfaceChecked: this.InitConfig.initFunction.indexOf('CurvedSurface') !== -1,
      cameraAssistChecked: this.InitConfig.initFunction.indexOf('CameraAssist') !== -1
    }
  },
  watch: {
    checkedFunctions (newValue) {
      this.searchTabOptions = this.getSearchTabOptions()
      this.searchTabValueChange()
      this.disableAdvancedFunction(newValue)
    },
    searchTabValue: {
      handler (newValue, oldValue) {
        newValue === 'Blending' || newValue === 'CurvedSurface' ? this.simulatorOptions[0].disabled = true : this.simulatorOptions[0].disabled = false
      },
      immediate: true
    },
    simulatorValue: {
      handler (newValue, oldValue) {
        if (newValue === 'Basic' && this.searchTabValue === '') {
          this.searchTabValue = this.checkedFunctions[0].value
        } else if (newValue === 'Top') {
          this.searchTabValue = ''
        }
        this.checkedFunctionsChangeHandler(newValue, oldValue)
        this.searchTabOptions = this.getSearchTabOptions()
        this.checkedFunctions = this.disableAdvancedFunction(this.checkedFunctions)
      }
    },
    edgeBlendingChecked (newValue) {
      this.searchTabOptions = this.getSearchTabOptions()
    },
    curvedSurfaceChecked (newValue) {
      this.searchTabOptions = this.getSearchTabOptions()
    }
  },
  computed: {
    ...mapState(['languageOptions', 'unitDataOptions']),
    options: {
      get () {
        return this.languageOptions
      }
    },
    isPortal () {
      return this.simulatorValue === 'Top'
    },
    isBasic () {
      return this.simulatorValue === 'Basic'
    },
    isAdvancedFunctionDisabled () {
      return this.simulatorValue !== 'Advanced'
    },
    functionOptions () {
      let value = this.isAdvancedFunctionDisabled ? basicFunctionOptions : basicFunctionOptions.concat(advancedFunctionOptions)
      return value
    },
    searchTabDisabled () {
      return this.isPortal
    }
  },
  methods: {
    saveFile () {
      let initFunction = this.getInitFunction()
      let fileData = {
        initLanguage: this.languageValue,
        initUnit: this.unitValue,
        initSearchTab: this.searchTabValue,
        initEsc: this.escValue,
        initSimulator: this.simulatorValue,
        initMain: this.simulatorValue === 'Top' ? 0 : 1,
        initFunction: initFunction // 模拟器function显示种类
      }
      let data = JSON.stringify(fileData)
      console.log(data)

      var blob = new Blob([data], { type: '' })
      saveAs(blob, 'initConfig.json')
    },
    searchTabValueChange () {
      if (this.isPortal) return
      let isHasSearchTabValue = this.isArrHasValue(this.checkedFunctions, this.searchTabValue)

      if (!isHasSearchTabValue) {
        this.searchTabValue = this.checkedFunctions[0].value
      }
    },
    disableAdvancedFunction (arrFun) {
      arrFun.map(item => {
        if (this.simulatorValue === 'Basic' && (item.value === 'Blending' || item.value === 'CurvedSurface')) {
          item.disabled = true
        } else {
          item.disabled = false
        }
      })
      return arrFun
    },
    // top或simple模式下 checkedFunctions的修改
    checkedFunctionsChangeHandler (newValue, oldValue) {
      if (oldValue === 'Advanced') {
        // 同步isBlendingChecked curvedSurfaceChecked的值 同时修改checkedFunctions
        let isHasEdgeBlending = this.isArrHasValue(this.checkedFunctions, 'Blending')
        let isHasCurvedSurface = this.isArrHasValue(this.checkedFunctions, 'CurvedSurface')
        if (isHasEdgeBlending) {
          this.edgeBlendingChecked = true
          this.deleteValueFromArr(this.checkedFunctions, 'Blending')
        } else {
          this.edgeBlendingChecked = false
        }
        if (isHasCurvedSurface) {
          this.curvedSurfaceChecked = true
          this.deleteValueFromArr(this.checkedFunctions, 'CurvedSurface')
        } else {
          this.curvedSurfaceChecked = false
        }

        // 如果前四个function都不勾选即当前checkedFunctions长度为0时 默认增加search projector
        if (!this.checkedFunctions.length) {
          this.checkedFunctions.push(basicFunctionOptions[0])
        }
      } else if (newValue === 'Advanced') {
        if (this.edgeBlendingChecked) {
          this.checkedFunctions.push(advancedFunctionOptions[0])
        }
        if (this.curvedSurfaceChecked) {
          this.checkedFunctions.push(advancedFunctionOptions[1])
        }
        this.searchTabValueChange()
      }
    },
    deleteValueFromArr (arr, value) {
      arr.splice(arr.findIndex(item => item.value === value), 1)
    },
    isArrHasValue (arr, value) {
      let isHas = false
      arr.map(item => {
        if (item.value === value) { isHas = true }
      })
      return isHas
    },
    getInitFunction () {
      let arr = this.checkedFunctions.map(item => { return item.value })
      if (this.isAdvancedFunctionDisabled) {
        if (this.edgeBlendingChecked) {
          arr.push(advancedFunctionOptions[0].value)
        }
        if (this.curvedSurfaceChecked) {
          arr.push(advancedFunctionOptions[1].value)
        }
        if (this.cameraAssistChecked) {
          arr.push(cameraFunctionOptions[0].value)
        }
      }
      return arr
    },
    getSearchTabOptions () {
      let arr = JSON.parse(JSON.stringify(this.checkedFunctions))
      if (this.isAdvancedFunctionDisabled) {
        if (this.edgeBlendingChecked && !this.isArrHasValue(arr, 'Blending')) {
          arr.push(advancedFunctionOptions[0])
        }
        if (this.curvedSurfaceChecked && !this.isArrHasValue(arr, 'CurvedSurface')) {
          arr.push(advancedFunctionOptions[1])
        }
        return this.disableAdvancedFunction(arr)
      } else {
        return this.checkedFunctions
      }
    }
  },
  mounted () {
    // 初始化checkedFunctions
    if (!this.checkedFunctions.length) {
      for (let i = 0; i < this.InitConfig.initFunction.length; i++) {
        this.functionOptions.map(item => {
          if (this.InitConfig.initFunction[i] === item.value) {
            item.disabled = false
            this.checkedFunctions.push(item)
          }
        })
      }
    }
    this.searchTabOptions = this.getSearchTabOptions()
    if (this.isPortal) {
      this.searchTabValue = ''
    }
  }
}
</script>
<style scoped>
.select-container{
  margin: 10px 70px
}
.row-item {
  line-height: 26px;
  padding:15px 0;
  border-bottom: 2px dashed #dad7d7;
}
.default-item{
  border-bottom:none;
}
.select {
  text-align: right;
}
.select-item{
  display: inline-block;
}
.default-lang,
.default-simulator{
  margin-bottom: 20px;
}
.el-select >>>.el-input__inner{
  width:180px!important;
  margin-left: 10px!important;
}
.el-checkbox-group {
  display: inline;
}
.el-checkbox-group >>>.el-checkbox,
.advanced-function-checkbox{
  color:#000000!important;
  width: 23%;
  margin-right: 10%!important;
  float: left
}
/* .function-row >>>.el-checkbox:nth-child(3n) {
  padding-left: 30px;
} */

.function-row >>> .el-checkbox__label{
  font-size: 16px!important;
}

.category_searchtab-title {
  font-size: 12px;
}

.categolies__radio {
  height: 45px;
  line-height: 45px;
  padding-left: 20px;
  border-right: 2px solid #bdbdbd;
  border-bottom: 1px solid #d3d3d3;
}

.categolies__select {
  height: 45px;
  padding-left: 20px;
  border-right: 2px solid #bdbdbd;
}

.label {
  float: left;
  line-height: 45px;
}

.label-select {
  width: 200px;
  float: left;
  padding-left: 10px;
}
.wrapper {
  height: 930px;
  border-right: 2px solid #bdbdbd;
}

.basic {
  color: #000000;
  font-weight: bold;
  padding: 15px 20px;
}

.default {
  height: 45px;
  padding-left: 20px;
}

.select-esc, .default-u {
  margin-right: 15px;
}

.default-l {
  margin-right: 31px;
}

.select-esc-none {
  margin-right: 55px;
  visibility: hidden;
}

.butbg {
  height: 792px;
  background: #f0f0f0;
}

.savefile {
  text-align: center;
  padding-top: 10px;
}

.input-label {
  height: 45px;
  line-height: 45px;
  text-align: right;
}
.default_simulator_input_label{
  padding-left: 0!important;
}

.input-box {
  padding: 0 10px;
}

</style>



// WEBPACK FOOTER //
// src/components/maintenanceTab/simulatorMainTab.vue